import React, {useEffect, useState} from 'react';
import {Box, Paper} from "@mui/material";
import {Loading} from "../../components";
import Button from "@mui/material/Button";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {connect} from "react-redux";
import MoreImage from "../../components/singleUploader/singleUploader";
import {Container} from "@mui/material";

const Index = (props) => {

    const {onComplete} = props;

    const [loading, setLoading] = useState(false);
    const [upFiles, setUpFiles] = useState([]);
    const [data, setData] = useState([]);


   useEffect(() => {
       new Api().get('/fileManager/overly')
           .then((response) => {
               if (typeof response !== "undefined") {
                   setData(response)
               }
           });
   } ,[])

    const handleSubmit = () => {
        setLoading(true)
        new Api().post('/fileManager/overly/upload', upFiles, false)
            .then((response) => {
                if (typeof response !== "undefined") {
                    if (response.status) {
                        setLoading(false)
                    } else {
                        setLoading(false)
                        toast.error(response.msg);
                    }
                }
            });

    }

    return (
        <Container>
            <div className='animate__animated animate__fadeIn'>
                <Box mt={5}>
                    <Paper style={{padding: '25px'}}>
                        <MoreImage data = {data?.details} onChange={(e) => setUpFiles(e)}/>
                    </Paper>
                </Box>
                <Box mt={2} className='display-flex display-flex-direction-row display-flex-justify-content-flex-end'>
                    <Button onClick={handleSubmit} disabled={loading} variant='contained' color='primary' type="submit">تکمیل اطلاعات</Button>
                </Box>
                {loading && <Loading/>}
            </div>
        </Container>
    );
};

const mapStateToProps = state => ({
    authReducer: state.authReducer
});


export default connect(mapStateToProps)(Index);